import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XMarkIcon } from '@heroicons/react/24/outline';

const cursos = [
  {
    nombre: 'Guitarra',
    img: require('../../../static/images/instrumentos/cards/guitarra.webp'),
    imgDetalle: require('../../../static/images/instrumentos/detail/guitarra.webp'),
    color: '#8A2BE2',
    tagline: 'Aquí no solo aprendes acordes.',
    descripcion: 'Aprendes a tocar esa canción que siempre dices "algún día". Trabajamos técnica, canciones actuales y montaje real para que veas tu avance rápido y con confianza.',
  },
  {
    nombre: 'Violín',
    img: require('../../../static/images/instrumentos/cards/violin.webp'),
    imgDetalle: require('../../../static/images/instrumentos/detail/violin.webp'),
    color: '#FF0000',
    tagline: 'Delicadeza que impacta.',
    descripcion: 'Trabajarás técnica, oído y sensibilidad para lograr un sonido limpio y expresivo. No solo interpretas música… la haces vibrar.',
    objectPosition: 'center',
  },
  {
    nombre: 'Piano',
    img: require('../../../static/images/instrumentos/cards/piano.webp'),
    imgDetalle: require('../../../static/images/instrumentos/detail/teclado.webp'),
    color: '#007BFF',
    tagline: 'Más que teclas, infinitas posibilidades.',
    descripcion: 'Aprenderás a dominar armonías, melodías y ritmos con técnica, expresión y creatividad. No solo tocas notas… creas atmósferas.',
    objectPosition: 'center',
  },
  {
    nombre: 'Batería',
    img: require('../../../static/images/instrumentos/cards/bateria.webp'),
    imgDetalle: require('../../../static/images/instrumentos/detail/bateria.webp'),
    color: '#FF6B35',
    tagline: 'Energía pura, precisión total.',
    descripcion: 'Desarrollarás coordinación, velocidad y fuerza para marcar el pulso con carácter y seguridad. No solo sigues el tiempo… lo impones.',
  },
  {
    nombre: 'Canto',
    img: require('../../../static/images/instrumentos/cards/canto.webp'),
    imgDetalle: require('../../../static/images/instrumentos/detail/canto.webp'),
    color: '#FF1493',
    tagline: 'Si cantas bajito para que nadie escuche…',
    descripcion: 'Aquí te ayudamos a cantar con seguridad. Trabajamos técnica e interpretación para que tu voz deje de esconderse.',
  },
  {
    nombre: 'Violonchelo',
    img: require('../../../static/images/instrumentos/cards/violonchelo.webp'),
    imgDetalle: require('../../../static/images/instrumentos/detail/violonchelo.webp'),
    color: '#00A36C',
    tagline: 'Profundidad que se siente.',
    descripcion: 'Aprenderás a dominar el arco y el cuerpo del instrumento con control y emoción. No solo acompañas… llenas el espacio con presencia.',
  },
  {
    nombre: 'Saxofón',
    img: require('../../../static/images/instrumentos/cards/saxofon.webp'),
    imgDetalle: require('../../../static/images/instrumentos/detail/saxofon.webp'),
    color: '#FFD700',
    tagline: 'Expresión en estado puro.',
    descripcion: 'Descubre cómo transformar el aire en emoción, desarrollar un sonido propio y moverte con libertad entre distintos estilos. Sensibilidad y fuerza en cada interpretación.',
  },
  {
    nombre: 'Acordeón',
    img: require('../../../static/images/instrumentos/cards/acordeon.webp'),
    imgDetalle: require('../../../static/images/instrumentos/detail/acordeon.webp'),
    color: '#14B8A6',
    tagline: 'Más versátil de lo que imaginas.',
    descripcion: 'Aprenderás repertorio actual y tradicional mientras desarrollas coordinación y presencia en escenario.',
  },
  {
    nombre: 'Bajo',
    img: require('../../../static/images/instrumentos/cards/bajo.webp'),
    imgDetalle: require('../../../static/images/instrumentos/detail/bajo.webp'),
    color: '#4F46E5',
    tagline: 'Menos protagonismo, más poder.',
    descripcion: 'Aquí aprenderás a crear líneas propias y tocar con groove, técnica y actitud. No solo sigues el ritmo… lo construyes.',
  },
];


export default function DescubreNuestrosCursos() {
  const [selected, setSelected] = useState(null);

  return (
    <>
      <section id="cursos" className="relative bg-white py-12 md:py-16 overflow-hidden">

        {/* Título */}
        <div className="text-center px-4 mb-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <p className="text-gray-400 uppercase tracking-[0.3em] text-xs mb-3">
              Lo que puedes aprender
            </p>
            <h2 className="text-4xl md:text-5xl font-black text-black">
              Descubre nuestros cursos
            </h2>
          </motion.div>
        </div>

        <div className="mx-auto px-4 md:px-8 pb-10" style={{ maxWidth: '806px' }}>
          <div className="grid grid-cols-3 gap-4">
            {cursos.map((curso, i) => (
              <button
                key={curso.nombre}
                onClick={() => setSelected(curso)}
                className="cursor-pointer rounded-2xl overflow-hidden border-0 bg-transparent p-0"
                style={{
                  aspectRatio: '521/785',
                  border: `3px solid ${curso.color}`,
                }}
              >
                <img
                  src={curso.img}
                  alt={`Clases de ${curso.nombre} en Academia Larghetto`}
                  className="w-full h-full object-cover scale-105"
                  loading="eager"
                  decoding="async"
                  draggable={false}
                />
              </button>
            ))}
          </div>
        </div>

      </section>

      <AnimatePresence>
        {selected && (
          <>
            <motion.div
              key="overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15 }}
              className="fixed inset-0 z-50 bg-black/70"
              onClick={() => setSelected(null)}
            />

            {/* Desktop: modal centrado */}
            <motion.div
              key="modal-desktop"
              initial={{ opacity: 0, scale: 0.95, y: 12 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 12 }}
              transition={{ duration: 0.2, ease: 'easeOut' }}
              className="fixed inset-0 z-50 hidden sm:flex items-center justify-center px-4 pointer-events-none"
            >
              <div
                className="relative bg-white rounded-3xl shadow-2xl overflow-hidden pointer-events-auto flex flex-row w-full max-w-2xl"
                style={{ borderTop: `4px solid ${selected.color}` }}
              >
                <div className="w-48 flex-shrink-0">
                  <img
                    src={selected.imgDetalle}
                    alt={selected.nombre}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 p-8 flex flex-col justify-center">
                  <p className="text-xs font-bold uppercase tracking-[0.25em] mb-2" style={{ color: selected.color }}>
                    {selected.nombre}
                  </p>
                  <h3 className="text-2xl font-black text-black leading-snug mb-3">
                    {selected.tagline}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">
                    {selected.descripcion}
                  </p>
                  <a
                    href={`https://wa.me/5576737753?text=${encodeURIComponent(`Hola, me interesa el curso de ${selected.nombre} en Larghetto.`)}`}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center justify-center gap-2 w-full py-3 px-6 rounded-2xl font-bold text-white text-sm"
                    style={{ backgroundColor: '#25D366' }}
                  >
                    Consultar por WhatsApp
                  </a>
                </div>
                <button
                  onClick={() => setSelected(null)}
                  className="absolute top-4 right-4 p-1.5 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
                  aria-label="Cerrar"
                >
                  <XMarkIcon className="w-4 h-4 text-gray-600" />
                </button>
              </div>
            </motion.div>

            {/* Mobile: bottom sheet */}
            <motion.div
              key="modal-mobile"
              initial={{ y: '100%' }}
              animate={{ y: 0 }}
              exit={{ y: '100%' }}
              transition={{ type: 'spring', damping: 30, stiffness: 300 }}
              className="fixed bottom-0 inset-x-0 z-50 sm:hidden pointer-events-auto"
              style={{ height: '85vh' }}
            >
              <div
                className="relative bg-white h-full rounded-t-3xl shadow-2xl overflow-hidden flex flex-col"
                style={{ borderTop: `4px solid ${selected.color}` }}
              >
                {/* Foto — ocupa ~55% del alto, desde top-0 */}
                <div className="relative flex-shrink-0" style={{ height: '55%' }}>
                  <img
                    src={selected.imgDetalle}
                    alt={selected.nombre}
                    className="w-full h-full object-cover"
                    style={{ objectPosition: selected.objectPosition || 'top' }}
                  />
                  {/* Pill handle flotando sobre la foto */}
                  <div className="absolute top-3 left-0 right-0 flex justify-center">
                    <div className="w-10 h-1 rounded-full bg-white/60" />
                  </div>
                </div>

                {/* Texto y botón — ocupa el resto */}
                <div className="flex-1 px-6 py-5 flex flex-col justify-between overflow-y-auto">
                  <div>
                    <p className="text-xs font-bold uppercase tracking-[0.25em] mb-1" style={{ color: selected.color }}>
                      {selected.nombre}
                    </p>
                    <h3 className="text-xl font-black text-black leading-snug mb-2">
                      {selected.tagline}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {selected.descripcion}
                    </p>
                  </div>
                  <a
                    href={`https://wa.me/5576737753?text=${encodeURIComponent(`Hola, me interesa el curso de ${selected.nombre} en Larghetto.`)}`}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center justify-center gap-2 w-full py-3 px-6 rounded-2xl font-bold text-white text-sm mt-4"
                    style={{ backgroundColor: '#25D366' }}
                  >
                    Consultar por WhatsApp
                  </a>
                </div>

                <button
                  onClick={() => setSelected(null)}
                  className="absolute top-4 right-4 p-1.5 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
                  aria-label="Cerrar"
                >
                  <XMarkIcon className="w-4 h-4 text-gray-600" />
                </button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
}
